
let lastId = 0
let modals = []
let callbacks = {
    onAdd: [],
    onRemove: [],
    onUpdate: []
}

/**
 * Run a list of callbacks.
 *
 * @param {array} callbacks List of callbacks to run
 */
const runCallbacks = function (callbacks) {
    callbacks.forEach(callback => {
        callback(modals)
    })
}

export default {
    /**
     * Get all active modals.
     *
     * @return array
     */
    get: function () {
        return modals
    },

    /**
     * Add a modal to the list.
     *
     * @param object options Key/value pair of options
     */
    add: function (options) {
        options.id = lastId++

        if (options.state === undefined) {
            options.state = "good"
        }

        modals.push(options)
        runCallbacks(callbacks.onAdd)
        runCallbacks(callbacks.onUpdate)
    },

    /**
     * Remove a modal from the list via its ID.
     *
     * @param string|int id Modal ID
     */
    remove: function (id) {
        modals = modals.filter(modal => modal.id !== id)

        runCallbacks(callbacks.onRemove)
        runCallbacks(callbacks.onUpdate)
    },

    /**
     * Add a listener callback that will get called when a modal is added.
     *
     * @param function listener Callback function
     */
    onAdd: function (listener) {
        callbacks.onAdd.push(listener)
    },

    /**
     * Add a listener callback that will get called when a modal is removed.
     *
     * @param function listener Callback function
     */
    onRemove: function (listener) {
        callbacks.onRemove.push(listener)
    },

    /**
     * Add a listener callback that will get called anytime the modal list is changed.
     *
     * @param function listener Callback function
     */
    onUpdate: function (listener) {
        callbacks.onUpdate.push(listener)
    }
}



// WEBPACK FOOTER //
// ./src/utilities/modal-manager.js